import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import Swiper from 'swiper';

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();

import { SharedModule } from 'src/app/layouts/full/shared/shared.module';

@Component({
  selector: 'app-pro-features-swiper',
  standalone: true,
  imports: [SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './pro-features-swiper.component.html',
  styleUrl: './pro-features-swiper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProFeaturesSwiperComponent {

  constructor() {
    const swiper = new Swiper('.swiper-container', {
      slidesPerView: 1, // Mostrar una diapositiva a la vez
      centeredSlides: true, // Centrar la diapositiva activa
      loop: true, // Hacer que las diapositivas sean infinitas
      spaceBetween: 20, // Espacio entre diapositivas
    });
  }


}
